import { useSelector } from "react-redux";
import type { IRootState } from "../../redux/store";
import { type TTab } from "../../utils";
import style from "./Form.module.scss";
import Avatar from "./NewInputs/AvatarFromBlock/Avatar";
import NewScene from "./NewInputs/SceneFromBlock/NewScene";

const TabStates: Partial<Record<TTab, any>> = {
	appearance: Avatar,
	scene: NewScene,
};

type Props = {
	activeTab: TTab;
	setActiveTab: (value: TTab) => void;
};

export const Form = ({ activeTab, setActiveTab }: Props) => {
	const formData = useSelector((state: IRootState) => state.avatarForm);
	const Component = TabStates[activeTab] || (() => {});

	const handleSaveForm = () => {
		switch (activeTab) {
			case "appearance":
				setActiveTab("scene");
				break;
			case "scene":
				setActiveTab("preview");
				break;
			default:
				setActiveTab("appearance");
				break;
		}
	};

	return (
		<div className={style.container}>
			<Component {...formData} handleSaveForm={handleSaveForm}/>
		</div>
	);
};
